import { DeleteOutlined, FormOutlined, PlusOutlined } from '@ant-design/icons'
import { Alert, Button, Card, Modal, Table } from 'antd'
import * as React from 'react'
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { FilterListBean, ItemResponseFilterListBeanObject, ListPagination } from 'src/api/api'
import { StorageKey, storageReaderFactory, storageWriterFactory } from 'src/util/Storage'
import { toSort, useSorter } from 'src/util/useSorter'
import filterListApi from './FilterListApi'

const Column = Table.Column

const storageWriter = storageWriterFactory('filterList')
const storageReader = storageReaderFactory('filterList')

interface Props { }

const FilterLists: React.FC<Props> = () => {

    const [data, setData] = useState<FilterListBean[]>([])
    const [pagination, setPagination] = useState<any>({
        defaultCurrent: 1,
        defaultPageSize: 10,
        current: 1
    })
    const [error, setError] = useState()

    const remove = (record: FilterListBean) => {
        Modal.confirm({
            title: `Delete ${record.name}?`,
            content: 'Are you sure?',
            cancelText: 'NO',
            okText: 'Yes, I\'m sure',
            onOk: async () => {
                try {
                    await filterListApi.delete(record.id as number)

                    let page = pagination.current
                    if (data.length == 1 && pagination.current > 1) {
                        page -= 1
                    }

                    loadData(page)
                } catch (e) {
                    setError(e.error)
                }
            }
        })
    }

    const loadData = async (page: number) => {

        const response = await filterListApi.list(pagination.defaultPageSize, page, toSort(sorter))

        const array = response.data as Array<ItemResponseFilterListBeanObject>
        const filterListBeans: FilterListBean[] = array.map(item => item.data as FilterListBean)

        if (filterListBeans.length == 0 && page > 1) {
            loadData(page - 1)
        } else {
            const newPagination: ListPagination = response.pagination as ListPagination
            storageWriter.write(StorageKey.SearchParams, {
                page: newPagination.currentPage
            })

            setData(filterListBeans)
            setPagination({ ...pagination, total: newPagination.total, current: newPagination.currentPage })
        }
    }

    const { sorter, handleTableChange } = useSorter(pagination, loadData)

    useEffect(() => {
        const searchParams = storageReader.read(StorageKey.SearchParams)
        const page = searchParams.page || pagination.current

        loadData(page)
    }, [sorter])

    return <Card
        title="Filter List"
        className="list-card"
        extra={<Link to={`/filter-list/create`} className="create-new-link">
            <Button type="primary" htmlType="button" icon={<PlusOutlined />}>
                New Filter List
            </Button>
        </Link>}
    >
        {error && <Alert message={error} type="error" />}
        <Table
            rowKey="id"
            size="middle"
            dataSource={data}
            pagination={{ ...pagination, size: 'default' }}
            onChange={handleTableChange}
        >
            <Column key="id" title="ID" dataIndex="id" sorter />
            <Column key="name" title="Name" dataIndex="name" sorter render={(text, record: FilterListBean) => <Link to={`/filter-list/${record.id}/edit`}>{text}</Link>} />
            <Column key="modified" title="Last Modified" dataIndex="modified" sorter />
            <Column align="center" key="action" title="Actions" render={(text: string, record: FilterListBean) =>
                <span>
                    <Link to={`/filter-list/${record.id}/edit`}>
                        <Button type="text" >
                            <FormOutlined className="actions-btn" />
                        </Button>
                    </Link>
                    <Button type="text" danger onClick={() => remove(record)}>
                        <DeleteOutlined />
                    </Button>
                </span>
            } />
        </Table>
    </Card>
}

export default FilterLists


// WEBPACK FOOTER //
// ./src/component/app/filterList/FilterLists.tsx